import React from "react";
import isEqual from "lodash/isEqual";
import isEmpty from "lodash/isEmpty";
import cloneDeep from "lodash/cloneDeep";
import { Spin, Row, Col, message, Tooltip } from "antd";
import WeaInputSearch from "../wea-input-search";
import WeaLocaleProvider from "../wea-locale-provider";
import ScrollTree from "./ScrollTree";
import {
  getAllKeys,
  filterDatas,
  traverTree,
  doFavEdit,
  doNoFavDelete,
  addLeaf,
  getDefautDatasShow
} from "./util";

import "react-virtualized/styles.css";
import "./react-virtualized-tree/src/main.css";
import WeaTools from "../wea-tools";
import WeaInput from "../base/wea-input-normal";
import WeaAvatar from "../wea-avatar";

const getLabel = WeaLocaleProvider.getLabel;

class WeaTree extends React.Component {
  static defaultProps = {
    prefixCls: "wea-left-tree",
    className: "",
    datas: [],
    dataUrl: "/api/hrm/base/getHrmSearchTree",
    loadUserUrl: `/api/hrm/base/getHrmSearchTree?isLoadUser=1`,
    counts: {},
    countsType: [],
    itemMainKey: "domid",
    defaultExpandLevel: 2,
    asyncLoad: false,
    searchKeys: ["name", "ecologyPinyinSearch"],
    onlyShowFav: false,
    showCollect: false,
    loading: false,
    ops: [],
    isOrg: false
  };
  constructor(props) {
    super(props);
    this.state = {
      datas: [],
      datasShow: [],
      selectedKeys: [],
      searchValue: "",
      dataUrl: props.isLoadUser ? props.loadUserUrl : props.dataUrl,
      ...this.updateData(props, true)
    };
  }
  componentWillReceiveProps(nextProps) {
    let state = {};
    if (
      nextProps.datas !== undefined &&
      !isEqual(
        getAllKeys(this.props.datas, this.props.isOrg && "nodeid"),
        getAllKeys(nextProps.datas, nextProps.isOrg && "nodeid")
      )
    ) {
      state = {
        ...state,
        ...this.updateData(nextProps)
      };
    }
    if (
      nextProps.expandedKeys !== undefined &&
      !isEqual(this.props.expandedKeys, nextProps.expandedKeys)
    ) {
      state = {
        ...state,
        expandedKeys: nextProps.expandedKeys
      };
    }
    this.setState(state);
  }
  updateData = (props, expanded) => {
    const { datas, defaultExpandLevel, expandedKeys: _e, isOrg } =
      props || this.props;
    // let _datas = cloneDeep(datas);
    let _datas = datas;
    this.formatData(_datas);
    let datasShow = !isOrg ? [..._datas] : [_datas];
    let expandedKeys =
      (_e && _e.length) > 0
        ? _e
        : this.state &&
          this.state.expandedKeys &&
          this.state.expandedKeys.length > 0
        ? this.state.expandedKeys
        : getAllKeys(
            getDefautDatasShow(_datas, defaultExpandLevel - 1),
            isOrg ? "nodeid" : "domid"
          ).keys;
    // if (asyncLoad) {
    //   datasShow = getDefautDatasShow(_datas, defaultExpandLevel);
    //   const total = getAllKeys(_datas, itemMainKey).num;
    //   const _total = getAllKeys(datasShow, itemMainKey).num;
    //   if (forceAsyn || (_total > 300 && total > 500)) {
    //     datasShow = getDefautDatasShow(_datas, 1);
    //     expandedKeys = [];
    //   }
    // }
    return {
      datas: _datas,
      datasShow,
      ...(defaultExpandLevel || expanded ? { expandedKeys } : {})
    };
  };
  formatData = data => {
    traverTree(data, obj => {
      const { props } = this;
      if (obj.deleted) return;
      obj.nodeid = obj.nodeid || obj.domid || obj.id;
      !obj.domid && (obj.domid = obj.nodeid);
      if (props.rowKey) {
        obj.nodeid = obj[props.rowKey];
      }
      if (props.renderNodeId) obj.nodeid = props.renderNodeId(obj);
      obj.id = obj.id || obj.key;
      obj.childs = obj.childs || [];
      if (!isEmpty(obj.children)) {
        obj.childs = obj.children;
        delete obj.children;
      }
      if (!isEmpty(obj.subs)) {
        obj.childs = obj.subs;
        delete obj.subs;
      }
      let isLeaf = true;
      if ("isLeaf" in obj && obj.isLeaf) {
        isLeaf = true;
      } else if (obj.isParent || obj.haschild) isLeaf = false;
      obj.isLeaf = isLeaf;
      if (!obj.isLeaf && !isEmpty(obj.childs)) {
        obj.isLoad = true;
      }
      if (!obj.isCheck && props.isOrg) {
        obj.isCheck = false;
      }
    });
    return data;
  };
  addChildToNode = (node, data, childs) => {
    const { rowKey, itemMainKey } = this.props;
    traverTree(data, obj => {
      if (
        (rowKey && node[rowKey] === obj[rowKey]) ||
        (node.id === obj.id && node.name === obj.name)
      ) {
        const _c = Array.isArray(childs)
          ? childs
          : childs.datas && childs.datas;
        obj.childs = _c;
        return true;
      }
      return false;
    });
  };
  loadData(node) {
    const { props } = this;
    const { loadData, noCache, isOrg } = this.props;
    if (loadData && (noCache || !node.isLoad)) {
      if (!isOrg) {
        return loadData(cloneDeep(node), this).then(data => {
          const { datasShow } = this.state;
          const datas = this.formatData(data.datas || []);
          this.addChildToNode(node, datasShow, datas);
          this.setState({ datasShow });
          props.onDatasChange && props.onDatasChange(datas);
        });
      } else {
        let searchParams = {
          type: node.type,
          id: node.id,
          isVirtual: node.isVirtual
        };
        return this.fetchData(searchParams, true, {}, false, false, node);
      }
    } else {
      return new Promise(resolve => {
        resolve();
      });
    }
  }
  fetchData(
    innerParams = {},
    fetchChildNode = false,
    outerParams = this.props.params,
    firstLoad = false,
    expandAllChildrenOnSearch = false,
    node
  ) {
    const { dataUrl, companysId, value } = this.state;
    const {
      onSelect,
      isLoadAllSub,
      isLoadSubDepartment,
      isLoadUser,
      vtreeMode = false,
      needDropMenu = false,
      defaultExpandedKeys,
      defaultCheckedDatas,
      defaultSelectedKeys
    } = this.props;
    let searchParams = { ...outerParams, ...innerParams, keyword: value };
    if (needDropMenu) searchParams.virtualCompanyid = companysId;
    if (isLoadAllSub || (expandAllChildrenOnSearch && value))
      searchParams.isLoadAllSub = "1";
    if (isLoadSubDepartment) searchParams.isLoadSubDepartment = "1";
    if (isLoadUser) searchParams.isLoadUser = "1";
    if (!fetchChildNode) {
      // 防止由于每次请求的根节点数据一致不会重新加载树
      const root = [...this.state.treeData];
      if (root[0]) root[0].needRefresh = true;
      this.setState({ loading: true, treeData: root });
    }
    return new Promise(resolve => {
      WeaTools.callApi(dataUrl, "GET", searchParams).then(data => {
        const { datasShow } = this.state;
        this.addChildToNode(node, datasShow, data);
        this.formatData(datasShow);
        this.setState({ datasShow });
        this.props.onDatasChange && this.props.onDatasChange(data);
      });
    });
  }
  expandTreeNode = node => {
    const { itemMainKey, loadData, noCache, isOrg, isLoadAllSub } = this.props;
    const { expandedKeys = [] } = this.state;
    const isopen = !node.isopen;
    let newExpandedKeys = [...expandedKeys];

    if (isopen) {
      newExpandedKeys.push(node[itemMainKey]);
    } else {
      newExpandedKeys = newExpandedKeys.filter(key => key != node[itemMainKey]);
    }
    if (
      isopen &&
      (isEmpty(node.childs) || noCache) &&
      loadData &&
      !(isOrg && isLoadAllSub)
    ) {
      this.loadData(node).then(() => {
        this.forceUpdate();
      });
    }
    this.onExpand(newExpandedKeys, { node, expanded: isopen });
  };
  onExpand = (expandedKeys, target) => {
    const { onExpand } = this.props;
    this.setState({ expandedKeys });
    target = target || { node: null, expanded: false };
    typeof onExpand === "function" && onExpand(expandedKeys, target);
  };
  onCheck(ks, e) {
    const { props } = this;
    let ids = [],
      nodeids = [],
      datas = [];
    ks &&
      ks.forEach(k => {
        const target = this.treeMap[k];
        if (target && target.treeKey == k) {
          ids.push(target.id);
          target.nodeid && nodeids.push(target.nodeid);
          datas.push(target);
        }
      });
    ids = uniq(ids);
    nodeids = uniq(nodeids);
    this.setState({ checkedKeys: !isEmpty(nodeids) ? nodeids : ids });
    props.onCheck && props.onCheck(ids, datas, e);
  }
  onRadioCheck(key) {
    const { props } = this;
    this.setState({
      radioCheckedKey: this.treeMap[key].nodeid || this.treeMap[key].id
    });
    props.onRadioCheck &&
      props.onRadioCheck(
        this.treeMap[key].id,
        this.treeMap[key].nodeid,
        this.treeMap[key]
      );
  }
  onSelect = (keys, countsType, node) => {
    const { counts, onSelect, isOrg } = this.props;
    const key = keys && keys.length > 0 ? keys[0] : "";
    this.setState({ selectedKeys: keys });
    if (typeof onSelect === "function" && key) {
      // 为兼容目前antd左侧树已存在功能 伪造eventNode数据
      const eventNode = {
        event: "select",
        node: {
          props: {
            ...node,
            browserTree: true,
            data: {
              domid: node.domid,
              haschild: node.haschild,
              isopen: node.isopen,
              key: node.key,
              name: node.name,
              isLeaf: node.isLeaf
            },
            isLeaf: node.isLeaf,
            level: node.deepness,
            children: node.childs
          }
        },
        selected: true,
        selectedNodes: [
          {
            key,
            props: {
              browserTree: true,
              data: {
                domid: node.domid,
                haschild: node.haschild,
                isopen: node.isopen,
                key: node.key,
                name: node.name,
                isLeaf: node.isLeaf
              },
              isLeaf: node.isLeaf,
              level: node.deepness,
              children: node.childs
            }
          }
        ]
      };
      onSelect(isOrg ? keys : key, counts ? counts[key] : "", eventNode);
    }
  };
  onSearchLabelClick = () => {
    const { onSearchLabelClick } = this.props;
    typeof onSearchLabelClick === "function" && onSearchLabelClick();
  };
  onSearchChange = v => {
    const {
      onSearchChange,
      defaultExpandLevel,
      asyncLoad,
      searchKeys,
      isOrg
    } = this.props;
    const { datas, expandedKeys } = this.state;
    const datasShow = v
      ? filterDatas(cloneDeep(datas), v, searchKeys)
      : asyncLoad
      ? getDefautDatasShow(datas, 1)
      : [...datas];
    this.setState({
      searchValue: v,
      datasShow,
      expandedKeys: v
        ? expandedKeys
        : asyncLoad
        ? []
        : getAllKeys(
            getDefautDatasShow(datas, defaultExpandLevel - 1),
            isOrg ? "nodeid" : "domid"
          ).keys
    });
    typeof onSearchChange === "function" && onSearchChange(v);
  };
  onCollect = (data, e) => {
    const { onCollect, onlyShowFav, itemMainKey } = this.props;
    typeof onCollect === "function" &&
      onCollect(data).then(res => {
        if (res.status === 1) {
          if (!res.hasDoFavToDatas) {
            let datasShow = doFavEdit(this.state.datasShow, data[itemMainKey]);
            if (onlyShowFav) datasShow = doNoFavDelete(datasShow);
            this.setState({ datasShow });
          }
          message.success(
            res.msg ||
              `${
                data.fav
                  ? getLabel("129248", "取消成功")
                  : getLabel("383218", "收藏成功")
              }！`
          );
        } else {
          message.warning(
            res.msg ||
              `${
                data.fav
                  ? getLabel("385902", "取消失败，请重试！")
                  : getLabel("385472", "收藏失败，请重试！")
              }`
          );
        }
      });
    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
    e.nativeEvent && e.nativeEvent.preventDefault();
  };
  onTitleNumClick = (keys, countsType, e) => {
    this.onSelect(keys, countsType);
    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
    e.nativeEvent && e.nativeEvent.preventDefault();
  };
  titleHoverIn = (countsTypeShow, e) => {
    $(e.target)
      .closest(".wea-tree-wrap")
      .find(".ant-tree-node-content-wrapper .titleNum")
      .each((index, item) => {
        $(item)
          .find(".wf-isshow")
          .css({ display: "inline-block" });
        $(item)
          .find("span")
          .each((i, m) => {
            $(m).css({
              "background-color": countsTypeShow[i].color,
              color: "#fff"
            });
          });
      });
  };
  titleHoverOut = (countsTypeShow, e) => {
    $(e.target)
      .closest(".wea-tree-wrap")
      .find(".ant-tree-node-content-wrapper .titleNum")
      .each((index, item) => {
        $(item)
          .find(".wf-isshow")
          .css({ display: "none" });
        $(item)
          .find("span")
          .each((i, m) => {
            $(m).css({
              color: countsTypeShow[i].color,
              "background-color": "transparent"
            });
          });
      });
  };
  getTitle = data => {
    const {
      showCollect,
      itemMainKey,
      counts,
      countsType,
      ops,
      prefixCls,
      isOrg,
      isLoadUser
    } = this.props;
    const countsTypeShow = [];
    let notShowEm = 0;
    const keys = [data[itemMainKey]];
    const flowSpan = showCollect
      ? [
          <i
            title={`${
              data.fav
                ? getLabel("129753", "取消收藏")
                : getLabel("22255", "添加收藏")
            }`}
            className={`icon-coms-Collection${data.fav ? "2" : ""}`}
            style={data.fav ? { color: "#ffa741" } : {}}
            onClick={e => this.onCollect(data, e)}
          />
        ]
      : [];
    countsType &&
      countsType.forEach(c => {
        let num =
          counts && counts[data[itemMainKey]]
            ? counts[data[itemMainKey]][c.name]
              ? counts[data[itemMainKey]][c.name]
              : ""
            : "";
        if (num && num !== "0") {
          notShowEm++;
          countsTypeShow.push(c);
          if (notShowEm !== 1) {
            flowSpan.push(
              <em
                className={c.isshow ? "" : "wf-isshow"}
                style={{ display: c.isshow ? "inline" : "none" }}
              >
                {" "}
                /{" "}
              </em>
            );
          }
          flowSpan.push(
            <span
              title={c.title}
              className={c.isshow ? "" : "wf-isshow"}
              style={{
                color: c.color,
                display: c.isshow ? "inline-block" : "none"
              }}
              onClick={e => this.onTitleNumClick(keys, c, e)}
            >
              {num}
            </span>
          );
        }
      });
    ops &&
      ops.length > 0 &&
      ops.forEach(op => {
        flowSpan.push(
          <div
            className={`${prefixCls}-ops`}
            key={op.key}
            onClick={() => typeof op.onClick === "function" && op.onClick(data)}
          >
            {op.show}
          </div>
        );
      });
    return (
      <Row
        onMouseEnter={e => this.titleHoverIn(countsTypeShow, e)}
        onMouseLeave={e => this.titleHoverOut(countsTypeShow, e)}
      >
        {isOrg && isLoadUser ? (
          this.renderTitle(data)
        ) : (
          <Col span="24" className="titleText text-elli" title={data.name}>
            {data.name}
          </Col>
        )}
        <Col span="24" className="titleNum">
          <div>{flowSpan}</div>
        </Col>
      </Row>
    );
  };
  renderOps(item) {
    const { ops, deleteText } = this.props;
    if (ops || item.ops) {
      const os = item.ops || ops;
      return (
        <div className="ops-wrapper inline-block">
          {os.map((o, idx) => (
            <Tooltip placement="bottom" title={this.getName(o)}>
              <i
                className={`${this.getIcon(o)} ops-icon`}
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.opsHandler(item, o);
                }}
              />
            </Tooltip>
          ))}
        </div>
      );
    }
  }
  renderTitle = item => {
    const { renderNode, renderItem, operations } = this.props;
    let title = (
      <div
        className="text-elli"
        style={{ paddingRight: 25 }}
        title={item.title || item.name}
      >
        {/*{item.icon && (*/}
        {/*  <i className={item.icon} style={{ marginRight: "5px" }} />*/}
        {/*)}*/}
        {item.displayName || item.name}
      </div>
    );
    if (item.displayType == "portrait") {
      let requestParams;
      try {
        if (item.requestParams) {
          requestParams = JSON.parse(item.requestParams);
        }
      } catch (e) {}
      title = (
        <div className="text-elli" style={{ height: 34 }}>
          {/* <img
            style={{ width: 30, height: 30, borderRadius: 15, padding: "1px" }}
            src={item.icon || item.img}
            alt="portrait"
          /> */}
          <WeaAvatar
            style={{ width: 26, height: 26, borderRadius: 15, padding: "1px" }}
            userId={item.id}
            key={item.id}
            requestParams={requestParams}
          />
          <span
            style={{ paddingLeft: 10, verticalAlign: "top" }}
            title={item.displayName || item.name}
          >
            {item.displayName || item.name}
          </span>
        </div>
      );
    }
    if (renderNode) {
      title = renderNode(item);
    }
    if (renderItem) {
      title = renderItem(item);
    }
    title = (
      <div class="wea-tree-node-wrapper text-elli">
        {title}
        {this.renderOps(item)}
      </div>
    );
    if (item.displayType == "add") {
      title = (
        <div class="wea-tree-node-wrapper">
          <WeaInput
            ref="input"
            style={{ width: 150 }}
            onBlur={v => this.addHandler(v, item)}
          />
        </div>
      );
    }
    if (item.displayType == "edit") {
      title = (
        <div class="wea-tree-node-wrapper">
          <WeaInput
            ref="input"
            style={{ width: 150 }}
            value={item.name}
            onBlur={v => this.editHandler(v, item)}
          />
        </div>
      );
    }
    return title;
  };
  getTree = datas => {
    return (
      <ScrollTree
        {...this.props}
        {...this.state}
        itemMainKey={this.props.isOrg ? "nodeid" : this.props.itemMainKey}
        datas={datas}
        getTitle={this.getTitle}
        onCheck={this.onCheck}
        onRadioCheck={this.onRadioCheck}
        onExpand={this.expandTreeNode}
        onSelect={(node, e) =>
          this.onSelect([node[this.props.itemMainKey]], e, node)
        }
      />
    );
  };
  render() {
    const { datasShow, searchValue } = this.state;
    const {
      prefixCls,
      className,
      style,
      loading,
      searchLabel,
      noDataLabel,
      needSearch = true,
      isOrg
    } = this.props;
    return (
      <div className={`${prefixCls} ${className}`} style={style}>
        <Spin spinning={loading}>
          {needSearch && !isOrg && (
            <div className={`${prefixCls}-search`}>
              <span
                className={`${prefixCls}-search-label`}
                onClick={this.onSearchLabelClick}
              >
                {searchLabel !== void 0
                  ? searchLabel
                  : getLabel("21979", "全部类型")}
              </span>
              <WeaInputSearch
                value={searchValue}
                onSearchChange={this.onSearchChange}
              />
            </div>
          )}
          <div
            className={`${prefixCls}-scroll`}
            style={isOrg ? { height: "100%" } : null}
          >
            {!datasShow.length && !loading ? (
              <p className={`${prefixCls}-noData`}>
                <i className="icon-coms-Invalid" />
                {noDataLabel !== void 0
                  ? noDataLabel
                  : getLabel("83553", "暂无数据")}
              </p>
            ) : (
              this.getTree(datasShow)
            )}
          </div>
        </Spin>
      </div>
    );
  }
}

export default WeaTree;



// WEBPACK FOOTER //
// ./ecology9/wea-tree-test/index.js